module.exports = __webpack_public_path__ + "img/1.07747d0c.png";